import { useState } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import DynamicSearchInput from 'components/Search/DynamicSearchInput';
import QuickSearchResults from 'components/Search/QuickSearchResults';
import Stack from '@mui/material/Stack';
import useTheme from '@mui/material/styles/useTheme';
import { navigationData } from './libNavigation';
import Collapse from '@mui/material/Collapse';
// import NavigationExploreMenu from './NavigationExploreMenu';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { uiContext } from 'contexts/UIContext';
// import debug from 'debug';
// const d = debug('homeNavigationMenu');

const HomeDesktopNavigationMenu = () => {
  const [activeTab, setActiveTab] = useState<string | undefined>(); //  'Explore gift cards'
  const [searchQuery, setSearchQuery] = useState<string>('');
  const theme = useTheme();
  // const { setShowExploreDrawer } = useContext(uiContext);

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const hideExploreMenu = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <Box
        sx={{
          maxWidth: {
            xs: 'initial',
            md: 640,
            lg: 840,
          },
          bgcolor: {
            md: 'secondary.dark',
          },
          boxShadow: {
            md: '0px 9px 40px rgba(0, 0, 0, 0.16)',
          },
          top: {
            xs: 42,
            md: theme.spacing(2.5),
          },
          borderRadius: 2.5,

          position: 'absolute',
          left: 0,
          right: 0,
          zIndex: 1100,
          margin: 'auto', // Center it...
        }}
      >
        <Toolbar
          style={{
            display: 'grid',
            alignItems: 'center',
            gridTemplateColumns: '1fr auto',
            minHeight: 60,
          }}
        >
          <Stack
            sx={{
              mr: { xs: 0, md: 2 },
            }}
            direction="row"
            flexGrow={1}
            justifyContent={{
              xs: 'space-between',
              sm: 'space-evenly',
            }}
          >
            {navigationData.map((navNode, idx) => {
              return (
                <Button
                  // Nav button...
                  sx={{
                    px: {
                      xs: 0,
                      sm: 1.375,
                    },
                    minWidth: 48,
                  }}
                  disableRipple
                  component={navNode.path ? RouterLink : 'div'}
                  variant="text"
                  size="large"
                  key={idx}
                  to={navNode.path}
                >
                  {(isMobile && navNode.mobileLabel) || navNode.label}
                </Button>
              );
            })}
          </Stack>
          <Box
            sx={{
              position: 'absolute',
              right: theme.spacing(1),
              maxWidth: 'calc(100% - 10px)',
              overflow: 'hidden',
              bgcolor: 'secondary.dark',
              display: {
                xs: 'none',
                md: 'block',
              },
            }}
          >
            <DynamicSearchInput
              active={activeTab === 'search'}
              onIconClick={() => {
                if (activeTab === 'search') {
                  setActiveTab(undefined);
                } else {
                  setActiveTab('search');
                }
              }}
              onQueryChange={(val) => {
                setSearchQuery(val);
              }}
              onClose={() => setActiveTab(undefined)}
              // source={history.location.pathname}
              sx={{ width: 'calc(840px - 68px)' }}
            />
          </Box>
        </Toolbar>
        <Collapse in={!hideExploreMenu && activeTab === 'search' && !!searchQuery && searchQuery.length >= 3}>
          <>
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                maxWidth: 840,
                minHeight: 60,
                bgcolor: 'secondary.dark',
                borderRadius: 2.5,
                margin: 'auto',
                marginTop: 1,
                // boxShadow: '0px 9px 40px rgba(0, 0, 0, 0.16)',
                // padding: 4,
              }}
            >
              <QuickSearchResults query={searchQuery} onClose={() => setActiveTab(undefined)} />
            </Box>
          </>
        </Collapse>
      </Box>
    </>
  );
};

export default HomeDesktopNavigationMenu;
